import { useMsal } from '@azure/msal-react';
import { useMemo, useState, useEffect } from 'react';

export const useUser = () => {
  const { accounts } = useMsal();
  const { idToken, name, idTokenClaims, username } = accounts[0] || {};

  const [isAuthTokenSet, setIsAuthTokenSet] = useState(false);

  // The isAuthTokenSet state is need ed to safely call the GET tenants ans user APIs
  // TODO: Review this after migrating the token logic to lib/axios.ts
  useEffect(() => {
    if (idToken && idTokenClaims?.exp) {
      setIsAuthTokenSet(true);
    }
  }, [idToken, idTokenClaims]);

  const user = useMemo(() => {
    const firstName = name?.split(' ')[0];
    const lastName = name?.split(' ').at(-1);
    const shortName = `${firstName?.[0]}${lastName?.[0]}`;

    return {
      idToken,
      idTokenClaims,
      firstName,
      lastName,
      shortName,
      email: username,
    };
  }, [idToken, name, idTokenClaims, username]);

  return {
    user,
    isAuthTokenSet,
  };
};
